module.exports = "<div ui-view\n  ng-cloak>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/stat/templates/index.html
// module id = 1540
// module chunks = 0